/**
 * Jurisdiction-specific privacy notices — resolved by UI language (en | es).
 */
import { LEGAL_COPY_EN } from '../i18n/data/legalNotices.en';
import { LEGAL_COPY_ES } from '../i18n/data/legalNotices.es';

export const PRIVACY_JURISDICTIONS = {
  AU: 'AU',
  CO: 'CO',
  ES: 'ES',
};

const COPY_BY_LANG = {
  en: LEGAL_COPY_EN,
  es: LEGAL_COPY_ES,
};

function resolveLang(language) {
  return language === 'es' ? 'es' : 'en';
}

/**
 * @param {'AU'|'CO'|'ES'} jurisdiction
 * @param {'en'|'es'} [language]
 */
export function getPrivacyNotice(jurisdiction, language = 'en') {
  const pack = COPY_BY_LANG[resolveLang(language)];
  const j = jurisdiction && pack.notices[jurisdiction] ? jurisdiction : 'AU';
  return {
    toggleCollapsed: pack.toggleCollapsed,
    toggleExpanded: pack.toggleExpanded,
    sections: pack.notices[j]?.sections || pack.notices.AU.sections,
  };
}

/**
 * @param {'AU'|'CO'|'ES'} jurisdiction
 * @param {'en'|'es'} [language]
 */
export function getConsentCopy(jurisdiction, language = 'en') {
  const pack = COPY_BY_LANG[resolveLang(language)];
  const j = jurisdiction && pack.consents[jurisdiction] ? jurisdiction : 'AU';
  return {
    fieldRequired: pack.fieldRequired,
    ...pack.consents[j],
  };
}

/** @deprecated Use getPrivacyNotice(jurisdiction, language) */
export const PRIVACY_NOTICES = {
  get AU() {
    return getPrivacyNotice('AU', 'en');
  },
  get CO() {
    return getPrivacyNotice('CO', 'es');
  },
  get ES() {
    return getPrivacyNotice('ES', 'es');
  },
};

/** @deprecated Use getConsentCopy(jurisdiction, language).fieldRequired */
export const CONSENT_FIELD_REQUIRED = LEGAL_COPY_EN.fieldRequired;
